import services from '@/config/services'

export default class MessaInMoraFattureClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }


  async sendPecInvoicesWithCmor(objs){
    let items = {}
    const url = `${this.baseUrl}/clienti/fatture/insolute/cmor/invio-pec`

    try {
        let res = await this.http.post(url, {objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


}
